import { useTranslation } from 'react-i18next';
import { useWindowSize } from '@scramble/hooks';
import { Button } from '@scramble/ui';
import IconBack from '@scramble/design-system/icons/arrow-left.svg';
import l from '../layout.module.scss';

export const LayoutNav = ({ className, onBack }) => {
  const { t } = useTranslation('investing');
  const { innerWidth } = useWindowSize();

  const isCompact = innerWidth <= 1200;

  return (
    <div className={className}>
      {isCompact ? (
        <Button
          theme="neutral"
          appearance="tonal"
          size="md"
          iconUrl={IconBack}
          className={l.btn_back}
          onClick={onBack}
        />
      ) : (
        <Button
          theme="neutral"
          appearance="tonal"
          size="md"
          className={l.btn_back}
          onClick={onBack}
        >
          <img src={IconBack} width={20} height={20} alt="back" />
          {t('layout.back')}
        </Button>
      )}
    </div>
  );
};


